// eslint-disable-next-line no-restricted-imports -- This file is the Kobo wrapper for the component
import { Textarea as TextareaMantine } from '@mantine/core'
import type { TextareaProps as TextareaPropsMantine } from '@mantine/core'

export type TextareaProps = TextareaPropsMantine

export default TextareaMantine
